import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { selectProductList, useGetProductListQuery } from "../../../services/productListApiSice";
import { SpareItem } from "../../../component/spares/SpareItem";
import classes from "./productListPage.module.css";
import { useSelector } from "react-redux";

export const ProductListPage = () => {
  const { category, inventory_id } = useParams();

  // Local state for pagination
  const [cursor, setCursor] = useState(0);
  const navigate = useNavigate();

  // Fetch data for the current cursor
  const { data, isFetching, isError, error } = useGetProductListQuery({
    category,
    inventory_id,
    cursor,
    pagination: 1,
    filters: {
      status: null,
      search: null,
    },
  });
  // const products = useSelector(selectProductList)

  const loaderRef = useRef(null);

  // Intersection Observer for infinite scroll
  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];
      if (target.isIntersecting && !isFetching && data?.length) {
        setCursor((prev) => prev + 1); // load next page
      }
    },
    [isFetching, data]
  );

  useEffect(() => {
    const option = { root: null, rootMargin: "20px", threshold: 1.0 };
    const observer = new IntersectionObserver(handleObserver, option);
    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [handleObserver]);

  const handleProductDetail = (id) => {
    console.log("Navigate to product detail:", id);
    navigate(`${id}`);
  };

  return (
    <div className={classes.box}>
      <div className={classes.box__head}>
        <h1 className={classes.box__head__title}>
          {`Inventory List : ${inventory_id}`}
        </h1>
      </div>

      <div className={classes.box__list}>
        {data?.map((spareItem) => (
          <SpareItem
            key={spareItem.id}
            item={spareItem}
            onClick={handleProductDetail}
          />
        ))}
      </div>

      {/* Infinite scroll loader trigger */}
      <div ref={loaderRef} style={{ height: "50px" }} />

      {isFetching && <p>Loading more...</p>}
      {isError && <p>Error: {error?.message}</p>}
    </div>
  );
};
